import React, { useMemo } from "react";
import { COLORS, FONT_BODY, FONT_DISPLAY, FONT_MONO } from "../theme.js";
import { fmtDate, fmtMoney } from "../domain/format.js";

export default function LegacyTimeline({ items }) {
  const events = useMemo(() => {
    const all = [];
    items.forEach((i) => {
      if (i.releaseDate) all.push({ key: `${i.id}-release`, date: i.releaseDate, label: "Released", itemName: `${i.brand} ${i.model}` });
      if (i.dateAdded) {
        all.push({
          key: `${i.id}-acquired`,
          date: i.dateAdded,
          label: `Acquired from ${i.purchasedFrom || "—"}${i.retail ? ` — ${fmtMoney(i.retail)}` : ""}`,
          itemName: `${i.brand} ${i.model}`,
        });
      }
      i.history.forEach((h, n) => all.push({ key: `${i.id}-h-${h.id || n}`, date: h.date, label: h.action, itemName: `${i.brand} ${i.model}` }));
    });
    return all.sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [items]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <span style={{ fontFamily: FONT_DISPLAY, fontSize: 20, color: COLORS.cream }}>Legacy Timeline</span>
      <div style={{ position: "relative", paddingLeft: 18 }}>
        <div style={{ position: "absolute", left: 4, top: 6, bottom: 6, width: 1, background: COLORS.line }} />
        {events.map((e) => (
          <div key={e.key} style={{ position: "relative", marginBottom: 18 }}>
            <div style={{ position: "absolute", left: -18, top: 3, width: 8, height: 8, borderRadius: "50%", background: COLORS.goldBright }} />
            <div style={{ fontFamily: FONT_MONO, fontSize: 10.5, color: COLORS.creamFaint }}>{fmtDate(e.date)}</div>
            <div style={{ fontFamily: FONT_BODY, fontSize: 13.5, color: COLORS.cream, marginTop: 2 }}>{e.label}</div>
            <div style={{ fontFamily: FONT_BODY, fontSize: 11.5, color: COLORS.creamDim }}>{e.itemName}</div>
          </div>
        ))}
        {events.length === 0 && (
          <div style={{ color: COLORS.creamFaint, fontFamily: FONT_BODY, fontSize: 13 }}>No timeline events yet — add an item or log some maintenance.</div>
        )}
      </div>
    </div>
  );
}
